import getPasswordChecks from './getPasswordChecks';

const passwordValidator =
  (t, userAttributes = {}) =>
  (_, value) => {
    if (!value) {
      return Promise.reject(new Error(t('Enter your password here')));
    }

    const { isAllValid } = getPasswordChecks(value, userAttributes);
    if (!isAllValid) {
      return Promise.reject(new Error(t('Create a strong password')));
    }

    return Promise.resolve();
  };

export default passwordValidator;
